const AbstractDialog = require("../common/AbstractDialog");
const Utils = require("../common/Utils");

/**
 * Dialog to display time selector to user
 *
 * @class
 */
var TimeSelectorDialog = function() {
    AbstractDialog.call(this);

    const MAX_TIME = 86399940; // 999 days, 23 hours, 59 minutes
    const MIN_TIME = 60; // 1 minute

    const self = this;
    const $content = this.getContent();
    $content.append($(require("html!./time_selector.html")));

    const $selector = $content.find(".timeSelector");
    const $limitsHeader = $content.find(".limitsHeader");
    const $doneButton = $content.find("#timeSelectorDoneButton");

    this.setTitle($.t("common::dynapps.setDuration.title"));

    let minTime = MIN_TIME;
    let maxTime = MAX_TIME;

    this.initialize = function(min, max) {
        minTime = min;
        maxTime = max;
        const minText = Utils.formatTimeAsString(Utils.splitTime(minTime), false, true);
        const maxText = Utils.formatTimeAsString(Utils.splitTime(maxTime), false, true);
        $limitsHeader.find("span").remove();

        if (max < MAX_TIME) {
            if (min > MIN_TIME) {
                $limitsHeader.append($("<span>", {text : $.t("common::dynapps.timeLimitsMinMax", {min : minText, max : maxText})}));
            } else {
                $limitsHeader.append($("<span>", {text : $.t("common::dynapps.timeLimitsMax", {max : maxText})}));
            }
        } else if (min > MIN_TIME) {
            $limitsHeader.append($("<span>", {text : $.t("common::dynapps.timeLimitsMin", {min : minText})}));
        }
    };

    // Call with seconds
    function isValidTime(newTime) {
        return (newTime >= minTime && newTime <= maxTime);
    }

    $doneButton.on("click", function() {
        const newTime = $selector.timeSelector("getTime");

        if (isValidTime(newTime)) {
            self.publishEvent("DynAppsController", "time-updated", {time : newTime});
            $content.popup("close");
        }
    });

    $(document).on("appready", function() {
        $selector.timeSelector();
    });

    $content.find("a:not(#timeSelectorDoneButton)").on("click", function() {
        self.publishEvent("DynAppsController", "cancel-time-selector");
    });

    $selector.on("timeupdated", function(event, days, hours, minutes) {
        const seconds = (days * 86400) + (hours * 3600) + (minutes * 60);

        if (isValidTime(seconds)) {
            $doneButton.removeClass("ui-disabled");
        } else {
            $doneButton.addClass("ui-disabled");
        }
    });

    const super_show = this.show;

    /**
     * @override
     */
    this.show = function() {
        super_show();
        self.publishEvent("DynAppsController", "time-selector-show");
    };
};

Utils.inherits(TimeSelectorDialog, AbstractDialog);

module.exports = TimeSelectorDialog;


//////////////////
// WEBPACK FOOTER
// ./dyn_apps/TimeSelectorDialog.js
// module id = 118
// module chunks = 0